import React, { useEffect, useState } from 'react';
import { View, Text, ActivityIndicator, FlatList } from "react-native-web";
import { DatePicker } from "antd";

import { connect, useDispatch, useSelector } from 'react-redux'

import AppointmentHandler from '../../components/AppointmentHandler';
import { searchAppointmentFromApi } from "../../../shared/actions/SearchAppointmentActions";
import { GetDayName, GetAppointmentDate, GetMonthName, ReturnTypeIcon, GetYear, FormateUTCTime, GetMonthNumber } from '../../../shared/core/datehelper'

import moment from "moment";
import getUserInfo from '../../../shared/core/GetTokenized';
import { appServices } from '../../../shared/redux/actions/appServices';

const { RangePicker } = DatePicker;
const SearchAppointmentView = props => {
    const [showAlert, setshowAlert] = useState(false)
    const [dateFrom, setdateFrom] = useState("")
    const [DateTo, setDateTo] = useState("")
    const dispatch = useDispatch();
    // const { SearchAppointment, isGettingSearch } = props.SearchAppointment;
    const dateFormat = 'DD-MM-YYYY';
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
      const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const  {AppointmentsData , isAppointmentsLoading} =useSelector((state)=> state.Appointments)
    const fAppointmentObj={
        PatientID: Profile[0].resource.id,
        ToDate : DateTo ,
        FromDate: dateFrom,
    }
    useEffect(() => {
        //alert('Called Future')
        // props.getAppoint(pageSize, pageNumber);
        if(props.activeKey=="5" && Profile && DateTo && dateFrom)
        dispatch(appServices.Appointments(fAppointmentObj))
    }, [props.activeKey , Profile])

    useEffect(() => {
       
        if(DateTo && dateFrom){
        dispatch(appServices.Appointments(fAppointmentObj))
    }
    }, [DateTo , dateFrom])
    
    //const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
    const dateChange = (date, dateString) => {
        if (date === null) {
        }
        else {

            console.log(date)
            console.log(JSON.stringify(date[0]))

            // // alert(dateString)
            // var str = dateString.toString();
            // //alert(str)
            // str = str.split(",");

            // let sDate = GetMonthNumber(str[0])// GetYear(str[0]) + '-' + GetMonthNumber(str[0]) + '-' + GetAppointmentDate(str[0])
            // props.searchAppointment(JSON.stringify(date[0]).replace(/['"]+/g, ''), JSON.stringify(date[1]).replace(/['"]+/g, ''))
          
            setdateFrom(JSON.stringify(date[0]).replace(/['"]+/g, ''))
            setDateTo(JSON.stringify(date[1]).replace(/['"]+/g, ''))
            // console.log(str);


            // console.log(moment(str[0]).format())

            // //var d = new Date(str[0]);

            // //console.log(d.getDate())
            // // var D = new Date(str[0]).toString().split("-");
            // //console.log(D[2] + "-" + D[1] + "-" + D[3]);
            // //alert(str[0] + '-----' + d.getFullYear())
        }

    }
    useEffect(() => {
        if(showAlert){
              // Dispatching the action to fetch appointments from the API
            //   dispatch(searchAppointmentFromApi(dateFrom, DateTo)) 
            const fAppointmentObj={
                PatientID: Profile[0].resource.id,
                ToDate : DateTo,
                FromDate: dateFrom ,
            }
            dispatch(appServices.Appointments(fAppointmentObj))     
          }
    }, [showAlert])
    const getTagStyles = (type) => {
        if (type === "Cancelled") {
            return 'card-header text-white bg-warning'
        }
        if (type === "Missed") {
            return 'card-header text-white bg-danger'
        }
        if(type === "Future") {
            return 'card-header text-white bg-primary'
        }
        if(type === "Completed") {
            return 'card-header text-white bg-success'
        }
    }
    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div style={{ marginLeft: 10, alignItems: 'center' }}>
                        <span className="badge badge-primary" style={{ marginLeft: 15, marginTop: 10 }}>Future</span>
                        <span className="badge badge-success" style={{ marginLeft: 15, marginTop: 10 }}>Completed</span>
                        <span className="badge badge-danger" style={{ marginLeft: 15, marginTop: 10 }}>Missed</span>
                        <span className="badge badge-warning" style={{ marginLeft: 15, marginTop: 10 }}>Cancelled </span>
                    </div>

                </div>
            </div>
            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: 10, paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>
                <Text>Select Dates: </Text>
                <RangePicker
                    format={dateFormat}
                    onChange={dateChange} />
            </View>


            {
                isAppointmentsLoading && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
            }
            {
                AppointmentsData && AppointmentsData.length ? (
                    <FlatList
                        style={{
                            flexDirection: 'column', paddingLeft: 10,
                            paddingRight: 10,
                            paddingBottom: 10
                        }}
                        //contentContainerStyle={{ flexDirection: "row", flexWrap: "wrap", justifyContent: 'space-evenly' }}
                        data={AppointmentsData}
                        renderItem={({ item }) => (
                            <AppointmentHandler
                                styleName={getTagStyles(item.resource.extension[6].valueString)}
                                appointmentDate={GetAppointmentDate(item.resource.period.start) + ' ' + GetMonthName(item.resource.period.start) + ' ' + GetYear(item.resource.period.start)}
                                praticeAddress={item.resource.extension[3].hasOwnProperty('valueString') ? item.resource.extension[3].valueString : '(N/A)'}
                                firstitem={item.resource.extension[2].valueString}
                                secondItem={GetDayName(item.resource.period.start) + ', ' + FormateUTCTime(item.resource.period.start)}
                                patientDetails={item.resource.extension[1].valueString} //+ ', ' + item.resource.extension[0].valueString}}
                                location={item.resource.extension[10].hasOwnProperty('valueString') ? item.resource.extension[10].valueString : '(N/A)'}
                                icTpye={'mdi mdi-18px mdi-alert-circle'} //this icons for cancel reason
                                reason={"Appointment Type: " + item.resource.extension[6].valueString}

                                icTpyeCancel={'mdi mdi-18px mdi-close-circle'}
                                reasonForCancel={item.resource.extension[6].valueString === "Cancelled" ? item.resource.extension[9].valueString !== undefined || item.resource.extension[9].valueString !== " " ? 'Reason: ' + item.resource.extension[9].valueString : 'Reason: N/A' : null}
                                IsAllowedReschedule={ item.resource.extension[12].valueBoolean}
                                ProviderScheduleID={parseInt(item.resource.extension[11].valueString)}
                                appointmentID={parseInt(item.resource.id)}
                                showAlert={showAlert}
                                setshowAlert={setshowAlert}
                                StartDate={item.resource.extension[13].valueDateTime}
                                EndDate={item.resource.extension[14].valueDateTime}
                               

                            />
                        )}
                        horizontal={false}
                        keyExtractor={item => item.resource.id}
                        initialNumToRender={30}

                    />
                ) : !isAppointmentsLoading && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ marginTop: 10, }}>No Records Found. Select Date to Search</Text>
                </View>
            }

            {/* <AppointmentHandler styleName={'card-header text-white bg-warning'} />
            <AppointmentHandler styleName={'card-header text-white bg-danger'} />
            <AppointmentHandler styleName={'card-header text-white bg-warning'} />
            <AppointmentHandler styleName={'card-header text-white bg-primary'} />
            <AppointmentHandler styleName={'card-header text-white bg-primary'} />
            <AppointmentHandler styleName={'card-header text-white bg-success'} /> */}
        </div>
    );
}


// function mapStateToProps(state) {
//     return {
//         SearchAppointment: state.SearchAppointment
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return {
//         searchAppointment: (fromDate, toDate) => dispatch(searchAppointmentFromApi(fromDate, toDate)),
//         //getMoreMissedAppoint: (pageSize, pageNumber) => dispatch(fetchMoreAppointmentsFromApi(pageSize, pageNumber))
//     }
// }



// export default connect(mapStateToProps, mapDispatchToProps)(SearchAppointmentView)

export default SearchAppointmentView
